// 构件 - 墙
import store from "@/store/index";
import rlModelData from "@/rlMxModules/rlDataClass/rlModelData";
import { getEntityData } from "@/rlMxModules/operate/operateApi";
import { McGePoint3d, McDbPolyline, McCmColor } from "mxcad";
import { rlTextData } from "./rlTextData";
import { getPKPM_WallData } from "@/rlMxModules/Opencascad/getModelDrawData.js";
import { calculateDistanceAndAngle } from "@/rlMxModules/operate/operateApi";
import { MovePt, checkRelationGuidData } from "../operate/structural";
import { getpickstatus } from "@/api/modelingList.js";
import { Poly_Triangle_1 } from "rl-opencascade.js";
class rlWallData extends rlModelData {
  getModel3dData = store.state.globalData.rl_wasm_module.getModel3dData;
  // wasm接口方法
  // getPKPM_WallData = store.state.globalData.rl_wasm_module.getPKPM_WallData;
  constructor() {
    super();
    this.componentType = "wall";
    this.points = []; // 顶点数据
    this.deviation = 0.00005;
    this.m_gridData = {}; //关联的网格数据
    // this.m_sectParamData = {}; //墙截面数据
    // this.SectData = []; //墙截面组合数据

    this.Ecc = null; //墙偏轴距离
    this.HDiff1 = null; //墙顶标高 1
    this.HDiff2 = null; //墙顶标高 2
    this.HDiffB = null; //墙底高（mm）

    this.Attribute = 1; //默认为主要构件
    this.classTypeName = "rlWallSeg"; // 墙

    this._threeObj = null; ////三维图形对象

    this.Color = null;
    this.ModelType = "墙";

    this.LinkGuids = null; //能合并为同一条梁的其他梁的guid
    this.m_groupName = "rlWallGroup"; //组名

    this.isWasmGeted = false; //是否已经获取wasm数据

    this.m_HoleId = null; //墙洞Id

    //检测鉴定数据
    this.m_jcData = [];

    //排查--房间命名
    this.useFunctionNames = [];
    //同类构件中主构件的guid
    this.m_RelationGuid = null;
    //同类构件数据--临时保存文字
    this.m_HomogeneousData = [];
    this.m_HomogeneousTextStrData = null; //同类构件中主构件的文字位置偏移
    this.otherDrawIds = []; //当门窗布置之后,隔墙二维要打断显示
    //检查构件文字--临时保存文字
    this.checkText = null;

    //格式为json:{1:[guid1,guid2,...],2:[guid1,guid2,...],...}
    this.ModelNoLinkData = []; //同一构件编号下的墙关联数据
    this.maxWallBeamNo = 0; //当前墙的墙梁数据的最大序号
    this.maxWallColNo = 0; //当前墙的墙柱数据的最大序号
  }

  initData(obj) {
    super.initData(obj);
    this.m_gridData = obj.m_gridData;

    this.Ecc = obj.Ecc;
    this.HDiff1 = obj.HDiff1;
    this.HDiff2 = obj.HDiff2;
    this.HDiffB = obj.HDiffB;
    this.Color = obj.Color;
    this.LinkGuids = obj.LinkGuids;

    this.index2dData = obj.index2dData;
    this.index3dData = obj.index3dData;
    this.points = obj.points;

    //与网格数据绑定
    this.m_gridData.m_wallId = this.Guid;
    this.useFunctionNames = obj.useFunctionNames ? obj.useFunctionNames : [];
    this.m_RelationGuid = obj.m_RelationGuid ? obj.m_RelationGuid : null;
    this.ModelNoLinkData = obj.ModelNoLinkData ? obj.ModelNoLinkData : "";
    this.maxWallBeamNo = obj.maxWallBeamNo ?? 0;
    this.maxWallColNo = obj.maxWallColNo ?? 0;
  }

  //隔墙打断二维显示
  drawBreakWall() {
    let startPoint = new McGePoint3d(...this.m_gridData.m_stJoint.m_pt);
    let endPoint = new McGePoint3d(...this.m_gridData.m_edJoint.m_pt);
    //计算网格的方向
    let dirLen = new THREE.Vector3(
      endPoint.x - startPoint.x,
      endPoint.y - startPoint.y,
      endPoint.z - startPoint.z
    );
    let dirWidth = dirLen.cross(new THREE.Vector3(0, 0, 1));
    dirWidth.normalize();
    if (Math.abs(this.Ecc) > 0) {
      startPoint.x -= Math.abs(dirWidth.x) * this.Ecc;
      startPoint.y += Math.abs(dirWidth.y) * this.Ecc;
      endPoint.x -= Math.abs(dirWidth.x) * this.Ecc;
      endPoint.y += Math.abs(dirWidth.y) * this.Ecc;
    }

    //删除原有的隔墙线
    this.eraseOtherDraw();
    if (!this.m_HoleId) {
      this.mcDbId.getMcDbEntity().visible = true;
      return;
    }

    if (!startPoint || !endPoint || !this.m_HoleId) {
      return;
    }
    this.mcDbId.getMcDbEntity().visible = false;

    // 获取所有门窗线段
    let holeLines = [];
    let rlDoorsWindows = getEntityData({
      Guid: this.m_HoleId,
      classTypeName: "rlWallHole",
    });
    if (rlDoorsWindows) {
      let ptLongCenterStart = rlDoorsWindows.draw2dData.ptLongCenterStart;
      let ptLongCenterEnd = rlDoorsWindows.draw2dData.ptLongCenterEnd;
      //对比ptLongCenterStart和ptLongCenterEnd距离墙起点的距离
      let distStart = ptLongCenterStart.distanceTo(startPoint);
      let distEnd = ptLongCenterEnd.distanceTo(startPoint);
      //如果ptLongCenterStart距离墙起点的距离大于ptLongCenterEnd距离墙起点的距离，则交换ptLongCenterStart和ptLongCenterEnd
      if (distStart > distEnd) {
        [ptLongCenterStart, ptLongCenterEnd] = [
          ptLongCenterEnd,
          ptLongCenterStart,
        ];
      }
      holeLines.push({
        startPoint: ptLongCenterStart,
        endPoint: ptLongCenterEnd,
      });
    }

    // 按照起点到墙起点的距离排序
    holeLines.sort((a, b) => {
      let distA = a.startPoint.distanceTo(startPoint);
      let distB = b.startPoint.distanceTo(startPoint);
      return distA - distB;
    });

    // 合并重叠的门窗线段
    let mergedHoleLines = [];
    for (let i = 0; i < holeLines.length; i++) {
      let current = holeLines[i];

      // 检查是否可以与前一个线段合并
      if (mergedHoleLines.length > 0) {
        let last = mergedHoleLines[mergedHoleLines.length - 1];
        if (current.startPoint.distanceTo(last.endPoint) <= this.deviation) {
          // 合并线段，取最远的终点
          if (
            current.endPoint.distanceTo(startPoint) >
            last.endPoint.distanceTo(startPoint)
          ) {
            last.endPoint = current.endPoint;
          }
          continue;
        }
      }
      mergedHoleLines.push(current);
    }

    // 计算未被打断的线段
    let remainingSegments = [];
    let currentStart = startPoint;

    // 按顺序处理每个门窗线段
    for (let i = 0; i < mergedHoleLines.length; i++) {
      let holeLine = mergedHoleLines[i];

      // 如果当前起点到门窗起点有一定距离，添加这段线段
      if (currentStart.distanceTo(holeLine.startPoint) > this.deviation) {
        remainingSegments.push({
          startPoint: currentStart,
          endPoint: holeLine.startPoint,
        });
      }

      // 更新当前起点为门窗终点
      currentStart = holeLine.endPoint;
    }

    // 添加最后一段（如果存在）
    if (currentStart.distanceTo(endPoint) > this.deviation) {
      remainingSegments.push({
        startPoint: currentStart,
        endPoint: endPoint,
      });
    }

    //创建二维俯视图
    const vecZ = new THREE.Vector3(0, 0, 1);
    let vecLong = new THREE.Vector3()
      .subVectors(endPoint, startPoint)
      .normalize();
    let vecShort1 = new THREE.Vector3();
    vecShort1.crossVectors(vecLong, vecZ).normalize();
    let vecShort2 = new THREE.Vector3(-vecShort1.x, -vecShort1.y, -vecShort1.z);
    for (let i = 0; i < remainingSegments.length; i++) {
      let line = new McDbPolyline();
      line.addVertexAt(
        MovePt(
          remainingSegments[i].startPoint,
          vecShort1,
          this.m_sectParamData.B / 2
        )
      );
      line.addVertexAt(
        MovePt(
          remainingSegments[i].endPoint,
          vecShort1,
          this.m_sectParamData.B / 2
        )
      );
      line.addVertexAt(
        MovePt(
          remainingSegments[i].endPoint,
          vecShort2,
          this.m_sectParamData.B / 2
        )
      );
      line.addVertexAt(
        MovePt(
          remainingSegments[i].startPoint,
          vecShort2,
          this.m_sectParamData.B / 2
        )
      );
      line.isClosed = true;
      line.setxDataString("Guid", this.Guid);
      line.setxDataString("classTypeName", this.classTypeName);
      line.trueColor = new McCmColor(this.Color.r, this.Color.g, this.Color.b);
      line.visible = store.state.displayData.wallDisplay;
      let polylineMcDb = rlAppObj.mxcadObject.drawEntity(line);
      this.otherDrawIds.push(polylineMcDb);
    }
    //处理文本显示控制的绑定关系
    if (this.otherDrawIds.length) {
      if (this.ModelNoTextObj) {
        this.ModelNoTextObj.belongObjId = this.otherDrawIds[0];
      }
      if (this.m_TextObj) {
        this.m_TextObj.belongObjId = this.otherDrawIds[0];
      }
      if (this.StrengthTextObj) {
        this.StrengthTextObj.belongObjId = this.otherDrawIds[0];
      }
    }
  }
  // 删除其他绘制数据
  eraseOtherDraw() {
    this.otherDrawIds.forEach((item) => {
      if (item) {
        item.erase();
      }
    });
    this.otherDrawIds = [];
  }
  //绘制同类构件文字
  drawHomogeneousData(data, isDisplay) {
    if (!data) {
      if (this.m_HomogeneousTextStrData) {
        data = this.m_HomogeneousTextStrData;
      } else {
        return;
      }
    } else {
      this.m_HomogeneousTextStrData = data;
    }
    if (this.m_HomogeneousData && this.m_HomogeneousData.length) {
      this.eraseHomogeneousData();
    }
    let fontSize = store.state.platBtns.fontSize;
    //矩形梁
    if (this.m_sectParamData.Kind == 1) {
      let pt1 = new McGePoint3d(this.index2dData[0], this.index2dData[1], 0);
      let pt2 = new McGePoint3d(this.index2dData[3], this.index2dData[4], 0);
      let pt3 = new McGePoint3d(this.index2dData[6], this.index2dData[7], 0);
      let pt4 = new McGePoint3d(this.index2dData[9], this.index2dData[10], 0);
      let vec1 = new THREE.Vector3().subVectors(pt3, pt2).normalize();
      let vec2 = new THREE.Vector3().subVectors(pt2, pt3).normalize();
      //砼
      if (this.m_sectParamData.Mat == 6) {
        if (data.horizonta_report_area != null) {
          let { angle } = calculateDistanceAndAngle(pt1, pt2);
          if (angle == 180) angle = 0;
          if (angle == 270) angle = 90;
          //转换成弧度
          angle = angle * (Math.PI / 180);
          let textObj = new rlTextData();
          let position = new McGePoint3d(
            (pt1.x + pt2.x) / 2,
            (pt1.y + pt2.y) / 2,
            0
          );
          //移动70避免与梁文字相撞
          position = MovePt(position, vec2, fontSize * 2);
          textObj.position = position;
          textObj.Text = "水平" + data.horizonta_report_area;
          textObj.fontSize = fontSize;
          textObj.dAngle = angle;
          textObj.textType = "配筋数据文字";
          textObj.McDbText.setxDataString("Guid", this.Guid);
          textObj.McDbText.setxDataString("classTypeName", this.classTypeName);
          textObj.draw(isDisplay);
          this.m_HomogeneousData.push(textObj.mcDbId);
        }
        if (data.vertical_report_area != null) {
          let { angle } = calculateDistanceAndAngle(pt4, pt3);
          if (angle == 180) angle = 0;
          if (angle == 270) angle = 90;
          //转换成弧度
          angle = angle * (Math.PI / 180);
          let textObj = new rlTextData();
          let position = new McGePoint3d(
            (pt4.x + pt3.x) / 2,
            (pt4.y + pt3.y) / 2,
            0
          );
          //移动70避免与梁文字相撞
          position = MovePt(position, vec1, fontSize * 2);
          textObj.position = position;
          textObj.Text = "竖向" + data.vertical_report_area;
          textObj.fontSize = fontSize;
          textObj.dAngle = angle;
          textObj.textType = "配筋数据文字";
          textObj.McDbText.setxDataString("Guid", this.Guid);
          textObj.McDbText.setxDataString("classTypeName", this.classTypeName);
          textObj.draw(isDisplay);
          this.m_HomogeneousData.push(textObj.mcDbId);
        }
      } else if (
        //砌体
        this.m_sectParamData.Mat == 1 ||
        this.m_sectParamData.Mat == 2 ||
        this.m_sectParamData.Mat == 3 ||
        this.m_sectParamData.Mat == 4
      ) {
        if (data.section_report_info && data.section_report_info.length > 0) {
          let { angle } = calculateDistanceAndAngle(pt1, pt2);
          if (angle == 180) angle = 0;
          if (angle == 270) angle = 90;
          //转换成弧度
          angle = angle * (Math.PI / 180);
          let textObj = new rlTextData();
          let position = new McGePoint3d(
            (pt1.x + pt2.x) / 2,
            (pt1.y + pt2.y) / 2,
            0
          );
          //移动70避免与梁文字相撞
          position = MovePt(position, vec2, 70);
          textObj.position = position;
          textObj.Text = "" + data.section_report_info[0];
          textObj.fontSize = fontSize;
          textObj.dAngle = angle;
          textObj.textType = "配筋数据文字";
          textObj.McDbText.setxDataString("Guid", this.Guid);
          textObj.McDbText.setxDataString("classTypeName", this.classTypeName);
          textObj.draw(isDisplay);
          this.m_HomogeneousData.push(textObj.mcDbId);
        }
      }
    }
  }

  //删除同类构件文字
  eraseHomogeneousData() {
    if (this.m_HomogeneousData && this.m_HomogeneousData.length) {
      this.m_HomogeneousData.forEach((objId) => {
        objId?.getMcDbEntity().erase();
      });
      this.m_HomogeneousData = [];
    }
  }

  //绘制检查构件文字
  async drawCheckText() {
    if (
      store.state.cadModules.rlProject_detail.businessTypePermission ===
      "investigate"
    ) {
      return;
    }
    const { data } = await getpickstatus({
      project_id: store.state.cadModules.rlProject_id,
      flr_guid: store.state.cadModules.rlBuilding.Guid,
      guid: this.Guid,
    });
    if (this.checkText) {
      this.checkText.getMcDbEntity().erase();
    }
    if (!data || !data.status) {
      return;
    }
    let fontSize = store.state.platBtns.fontSize;
    const isShowWall = this.getCheckStatus(6);
    const isCheckCheckText = this.getCheckStatus(25);
    let display = isShowWall && isCheckCheckText;
    //矩形
    if (this.m_sectParamData.Kind == 1) {
      let pt1 = new McGePoint3d(...this.m_gridData.m_stJoint.m_pt);
      let pt2 = new McGePoint3d(...this.m_gridData.m_edJoint.m_pt);
      if (data.content) {
        let { angle } = calculateDistanceAndAngle(pt1, pt2);
        if (angle == 180) angle = 0;
        if (angle == 270) angle = 90;
        //转换成弧度
        angle = angle * (Math.PI / 180);
        let textObj = new rlTextData();
        let position = new McGePoint3d(
          (pt1.x + pt2.x) / 2,
          (pt1.y + pt2.y) / 2,
          0
        );
        textObj.position = position;
        textObj.Text = "墙(检:" + data.content + ")";
        textObj.fontSize = fontSize;
        textObj.dAngle = angle;
        textObj.textType = "配筋数据文字";
        textObj.McDbText.setxDataString("Guid", this.Guid);
        textObj.McDbText.setxDataString("classTypeName", this.classTypeName);
        textObj.draw(display);
        this.checkText = textObj.mcDbId;
      }
    }
  }

  //根据guid获取checkbox的点击状态
  getCheckStatus(guid) {
    return store.state.displayData.rlLayerDisplay.includes(guid);
  }

  //删除检查构件文字
  eraseCheckText() {
    if (this.checkText) {
      this.checkText.getMcDbEntity().erase();
    }
  }

  drawJcData(jcDatas, bShow, showType /*3==高厚比，4==受压，5==抗震 */) {
    if (!jcDatas || jcDatas.length == 0) {
      return;
    }

    //剔除重复数据
    jcDatas = jcDatas.filter(
      (item, index, self) =>
        index === self.findIndex((obj) => obj.No === item.No)
    );
    //对数据排序
    jcDatas = jcDatas.sort((a, b) => {
      a.No - b.No > 0;
    });

    let jcDataObj = jcDatas[0];

    if (this.m_jcData && this.m_jcData.length) {
      this.eraseJcData();
    }
    let fontSize = store.state.platBtns.fontSize;
    //计算网格线
    let pt1 = new McGePoint3d(
      this.m_gridData.m_stJoint.m_pt[0],
      this.m_gridData.m_stJoint.m_pt[1],
      0
    );
    let pt2 = new McGePoint3d(
      this.m_gridData.m_edJoint.m_pt[0],
      this.m_gridData.m_edJoint.m_pt[1],
      0
    );
    //如果起点到终点的方向向左或者向下，则交换起点和终点
    if (pt1.x > pt2.x || pt1.y > pt2.y) {
      let tmp = pt1;
      pt1 = pt2;
      pt2 = tmp;
    }
    let ptCenter = new McGePoint3d((pt1.x + pt2.x) / 2, (pt1.y + pt2.y) / 2, 0);

    let gridVec = new THREE.Line3(
      new THREE.Vector3(pt1.x, pt1.y, 0),
      new THREE.Vector3(pt2.x, pt2.y, 0)
    )
      .delta()
      .normalize();

    //若gridVec方向指向左下，则取反
    if (gridVec.x < 0 || gridVec.y < 0) {
      gridVec.multiplyScalar(-1);
    }
    var angle = gridVec.angleTo(new THREE.Vector3(1, 0, 0));
    //计算gridVec的垂直方向
    let gridVecPrep = new THREE.Vector3();
    gridVecPrep.crossVectors(gridVec, new THREE.Vector3(0, 0, 1));

    if (this.m_sectParamData.Mat == 6) {
      //混凝土
      if (jcDataObj.Ashw || jcDataObj.Asvw || jcDataObj.Asw) {
        if (jcDataObj.Ashw) {
          let textObj = new rlTextData();
          textObj.position = new McGePoint3d(
            ptCenter.x + gridVecPrep.x * fontSize * 2,
            ptCenter.y + gridVecPrep.y * fontSize * 2,
            0
          );
          textObj.Text = "H" + jcDataObj.Ashw;
          // if (jcDataObj.Asv) {
          //   textObj.Text += "-V" + jcDataObj.Asv;
          //   if ((jcDataObj.isDouble = "1")) {
          //     textObj.Text += "(双侧/m)";
          //   }
          // }

          textObj.fontSize = fontSize;
          textObj.dAngle = angle;
          if (jcDataObj.ProblemError && jcDataObj.ProblemError.includes("1")) {
            textObj.color = new McCmColor(255, 0, 0);
          }
          textObj.textType = "计算结果";
          textObj.draw(showType == 2);
          this.m_jcData.push(textObj.mcDbId);
        }
        if (jcDataObj.Asw != null) {
          let textObj = new rlTextData();
          textObj.position = new McGePoint3d(
            ptCenter.x - gridVecPrep.x * fontSize * 2,
            ptCenter.y - gridVecPrep.y * fontSize * 2,
            0
          );
          textObj.Text = jcDataObj.Asw;
          if (jcDataObj.UC) {
            textObj.Text += "(" + jcDataObj.UC + ")";
          }
          textObj.fontSize = fontSize;
          textObj.dAngle = angle;
          textObj.textType = "计算结果";
          textObj.draw(showType == 2);
          if (jcDataObj.ProblemError && jcDataObj.ProblemError.includes("2")) {
            textObj.color = new McCmColor(255, 0, 0);
          }
          this.m_jcData.push(textObj.mcDbId);
        }
      } else if (this.m_HoleId && jcDatas.length > 1) {
        let holeData = getEntityData({
          Guid: this.m_HoleId,
          classTypeName: "rlWallHole",
        });
        if (!holeData || !holeData.m_sectParamData) return;
        let holeLineSt = pt1; //洞口线起点
        let holeLineEd = pt2; //洞口线终点
        let holesect_B = holeData.m_sectParamData.B;
        if (holeData.Ecc == 1) {
          holeLineEd = new THREE.Vector3(
            pt1.x + gridVec.x * holesect_B,
            pt1.y + gridVec.y * holesect_B
          );
        } else if (holeData.Ecc == -1) {
          holeLineSt = new THREE.Vector3(
            pt2.x - gridVec.x * holesect_B,
            pt2.y - gridVec.y * holesect_B
          );
        } else {
          let holeEcc = holeData.Ecc;
          //居中
          if (holeData.Ecc == 0) {
            holeEcc = pt1.distanceTo(pt2) / 2 - holesect_B / 2;
          }
          holeLineSt = new THREE.Vector3(
            pt1.x + gridVec.x * holeEcc,
            pt1.y + gridVec.y * holeEcc
          ); //墙洞线起点
          holeLineEd = new THREE.Vector3(
            pt1.x + gridVec.x * (holeEcc + holesect_B),
            pt1.y + gridVec.y * (holeEcc + holesect_B)
          ); //墙洞线终点
        }

        let wallBeamData = jcDatas.filter(
          (item) =>
            item.Asv ||
            item.Asv0 ||
            item.Asu1 ||
            item.Asu2 ||
            item.Asu3 ||
            item.Asu1 ||
            item.Asd1 ||
            item.Asd2 ||
            item.Asd3
        );
        let wallColData = jcDatas.filter((item) => item.AstH || item.AstM);
        //绘制墙梁数据
        if (wallBeamData.length > 0) {
          wallBeamData = wallBeamData[0];
          let ptText = new McGePoint3d(
            (holeLineSt.x + holeLineEd.x) / 2,
            (holeLineSt.y + holeLineEd.y) / 2,
            0
          );
          this.drawHntJcData(
            wallBeamData,
            ptText,
            gridVecPrep,
            angle,
            fontSize,
            showType,
            false
          );
        }

        if (wallColData.length > 0) {
          if (holeData.Ecc == 1 || holeData.Ecc == -1) {
            //一个墙柱数据
            let ptText = ptCenter;
            if (holeData.Ecc == 1) {
              ptText = new McGePoint3d(
                (holeLineEd.x + pt2.x) / 2,
                (holeLineEd.y + pt2.y) / 2,
                0
              );
            } else {
              ptText = new McGePoint3d(
                (pt1.x + holeLineSt.x) / 2,
                (pt1.y + holeLineSt.y) / 2,
                0
              );
            }
            this.drawHntJcData(
              wallColData[0],
              ptText,
              gridVecPrep,
              angle,
              fontSize,
              showType,
              true
            );
          } else if (wallColData.length > 1) {
            //两个墙柱数据
            let ptText1 = new McGePoint3d(
              (pt1.x + holeLineSt.x) / 2,
              (pt1.y + holeLineSt.y) / 2,
              0
            );
            this.drawHntJcData(
              wallColData[0],
              ptText1,
              gridVecPrep,
              angle,
              fontSize,
              showType,
              true
            );

            let ptText2 = new McGePoint3d(
              (holeLineEd.x + pt2.x) / 2,
              (holeLineEd.y + pt2.y) / 2,
              0
            );
            this.drawHntJcData(
              wallColData[1],
              ptText2,
              gridVecPrep,
              angle,
              fontSize,
              showType,
              true
            );
          }
        }
      } else {
        this.drawHntJcData(
          jcDataObj,
          ptCenter,
          gridVecPrep,
          angle,
          fontSize,
          showType,
          true
        );
      }
    } else if (
      jcDataObj.PCNo ||
      jcDataObj.PGNo ||
      jcDataObj.CalHTR ||
      jcDataObj.KzjsRLR ||
      jcDataObj.ZxsyRLR
    ) {
      // if (jcDataObj.PCNo) {
      //   //非高厚比编号
      //   let textObj = new rlTextData();
      //   textObj.position = new McGePoint3d(
      //     ptCenter.x - gridVecPrep.x * 200,
      //     ptCenter.y - gridVecPrep.y * 200,
      //     0
      //   );
      //   textObj.Text = jcDataObj.PCNo;
      //   textObj.fontSize = fontSize;
      //   textObj.dAngle = angle;
      //   textObj.draw(showType == 3);
      //   this.m_jcData.push(textObj.mcDbId);
      // }

      // if (jcDataObj.PGNo) {
      //   //非高厚比编号
      //   let textObj = new rlTextData();
      //   textObj.position = new McGePoint3d(
      //     ptCenter.x - gridVecPrep.x * 200,
      //     ptCenter.y - gridVecPrep.y * 200,
      //     0
      //   );
      //   textObj.Text = jcDataObj.PGNo;
      //   textObj.fontSize = fontSize;
      //   textObj.dAngle = angle;
      //   textObj.draw(showType != 3);
      //   this.m_jcData.push(textObj.mcDbId);
      // }

      if (jcDataObj.CalHTR && jcDataObj.AllowHTR) {
        //高厚比
        let textObj = new rlTextData();
        textObj.position = new McGePoint3d(ptCenter.x, ptCenter.y, 0);
        textObj.Text = jcDataObj.CalHTR + "/" + jcDataObj.AllowHTR;
        textObj.fontSize = fontSize;
        textObj.dAngle = angle;
        if (jcDataObj.ProblemError && jcDataObj.ProblemError.includes("3")) {
          textObj.color = new McCmColor(255, 0, 0);
        }
        textObj.textType = "计算结果";
        textObj.draw(showType == 3);
        this.m_jcData.push(textObj.mcDbId);
      }
      //抗震
      if (jcDataObj.KzjsRLR && jcDataObj.KzjsRLR != "Array") {
        let KzjsRLR = jcDataObj.KzjsRLR.split(",");

        if (KzjsRLR.length > 1) {
          let textObj = new rlTextData();
          textObj.position = new McGePoint3d(
            pt1.x + gridVec.x * fontSize * 5,
            pt1.y + gridVec.y * fontSize * 5,
            0
          );
          textObj.Text = KzjsRLR[0];
          textObj.fontSize = fontSize;
          textObj.dAngle = angle;
          if (jcDataObj.ProblemError && jcDataObj.ProblemError.includes("1")) {
            textObj.color = new McCmColor(255, 0, 0);
          }
          textObj.textType = "计算结果";
          textObj.draw(showType == 5);
          this.m_jcData.push(textObj.mcDbId);

          let textObj2 = new rlTextData();
          textObj2.position = new McGePoint3d(
            pt2.x - gridVec.x * fontSize * 5,
            pt2.y - gridVec.y * fontSize * 5,
            0
          );
          textObj2.Text = KzjsRLR[1];
          textObj2.fontSize = fontSize;
          textObj2.dAngle = angle;
          textObj2.draw(showType == 5);
          if (jcDataObj.ProblemError && jcDataObj.ProblemError.includes("1")) {
            textObj2.color = new McCmColor(255, 0, 0);
          }
          this.m_jcData.push(textObj2.mcDbId);
        } else {
          let textObj = new rlTextData();
          textObj.position = new McGePoint3d(ptCenter.x, ptCenter.y, 0);
          textObj.Text = KzjsRLR;
          textObj.fontSize = fontSize;
          textObj.dAngle = angle;
          textObj.textType = "计算结果";
          textObj.draw(showType == 5);
          if (jcDataObj.ProblemError && jcDataObj.ProblemError.includes("1")) {
            textObj.color = new McCmColor(255, 0, 0);
          }
          this.m_jcData.push(textObj.mcDbId);
        }
      }
      //受压
      if (jcDataObj.ZxsyRLR && jcDataObj.ZxsyRLR != "Array") {
        let ZxsyRLR = jcDataObj.ZxsyRLR.split(",");
        if (ZxsyRLR.length > 1) {
          let textObj = new rlTextData();
          textObj.position = new McGePoint3d(
            pt1.x + gridVec.x * fontSize * 5,
            pt1.y + gridVec.y * fontSize * 5,
            0
          );
          textObj.Text = ZxsyRLR[0];
          textObj.fontSize = fontSize;
          textObj.dAngle = angle;
          textObj.textType = "计算结果";
          textObj.draw(showType == 4);
          if (jcDataObj.ProblemError && jcDataObj.ProblemError.includes("2")) {
            textObj.color = new McCmColor(255, 0, 0);
          }
          this.m_jcData.push(textObj.mcDbId);

          let textObj2 = new rlTextData();
          textObj2.position = new McGePoint3d(
            pt2.x - gridVec.x * fontSize * 5,
            pt2.y - gridVec.y * fontSize * 5,
            0
          );
          textObj2.Text = ZxsyRLR[1];
          textObj2.fontSize = fontSize;
          textObj2.dAngle = angle;
          textObj2.draw(showType == 4);
          if (jcDataObj.ProblemError && jcDataObj.ProblemError.includes("2")) {
            textObj2.color = new McCmColor(255, 0, 0);
          }
          this.m_jcData.push(textObj2.mcDbId);
        } else {
          let textObj = new rlTextData();
          textObj.position = new McGePoint3d(ptCenter.x, ptCenter.y, 0);
          textObj.Text = jcDataObj.ZxsyRLR;
          textObj.fontSize = fontSize;
          textObj.dAngle = angle;
          textObj.textType = "计算结果";
          textObj.draw(showType == 4);
          if (jcDataObj.ProblemError && jcDataObj.ProblemError.includes("2")) {
            textObj.color = new McCmColor(255, 0, 0);
          }
          this.m_jcData.push(textObj.mcDbId);
        }
      }
    }

    store.commit("rlEntData/editEntityData", {
      Guid: this.Guid,
      classTypeName: this.classTypeName,
    });
  }

  //将混凝土计算数据封装出来
  drawHntJcData(
    jcDataObj,
    ptCenter,
    gridVecPrep,
    angle,
    fontSize,
    showType,
    isWallCol
  ) {
    if (isWallCol) {
      if (jcDataObj.AstH) {
        let textObj = new rlTextData();
        textObj.position = new McGePoint3d(
          ptCenter.x + gridVecPrep.x * fontSize * 2,
          ptCenter.y + gridVecPrep.y * fontSize * 2,
          0
        );
        textObj.Text = "H" + jcDataObj.AstH;
        if (jcDataObj.Asv) {
          textObj.Text += "-V" + jcDataObj.Asv;
          if ((jcDataObj.isDouble = "1")) {
            textObj.Text += "(双侧/m)";
          }
        }

        textObj.fontSize = fontSize;
        textObj.dAngle = angle;
        if (jcDataObj.ProblemError && jcDataObj.ProblemError.includes("1")) {
          textObj.color = new McCmColor(255, 0, 0);
        }
        textObj.textType = "计算结果";
        textObj.draw(showType == 2);
        this.m_jcData.push(textObj.mcDbId);
      }
      if (jcDataObj.AstM != null) {
        let textObj = new rlTextData();
        textObj.position = new McGePoint3d(
          ptCenter.x - gridVecPrep.x * fontSize * 2,
          ptCenter.y - gridVecPrep.y * fontSize * 2,
          0
        );
        textObj.Text = jcDataObj.AstM;
        if (jcDataObj.UC) {
          textObj.Text += "(" + jcDataObj.UC + ")";
        }
        textObj.fontSize = fontSize;
        textObj.dAngle = angle;
        textObj.textType = "计算结果";
        textObj.draw(showType == 2);
        if (jcDataObj.ProblemError && jcDataObj.ProblemError.includes("2")) {
          textObj.color = new McCmColor(255, 0, 0);
        }
        this.m_jcData.push(textObj.mcDbId);
      }
    } else {
      if (jcDataObj.Asv && jcDataObj.Asv0) {
        let textObj = new rlTextData();
        let x = ptCenter.x - (gridVecPrep.x * fontSize) / 2;
        let y = ptCenter.y - (gridVecPrep.y * fontSize) / 2;
        textObj.position = new McGePoint3d(x, y, 0); // new McGePoint3d(ptCenter.x, ptCenter.y + 200, 0);
        textObj.Text = "G" + jcDataObj.Asv + "-" + jcDataObj.Asv0;
        textObj.fontSize = fontSize;
        textObj.dAngle = angle;
        if (jcDataObj.ProblemError && jcDataObj.ProblemError.includes("1")) {
          textObj.color = new McCmColor(255, 0, 0);
        }
        textObj.textType = "计算结果";
        textObj.draw(showType == 2);
        this.m_jcData.push(textObj.mcDbId);
      }

      if (jcDataObj.Asu1 && jcDataObj.Asu2 && jcDataObj.Asu3) {
        let textObj = new rlTextData();
        let x = ptCenter.x + gridVecPrep.x * fontSize;
        let y = ptCenter.y + gridVecPrep.y * fontSize;
        textObj.position = new McGePoint3d(x, y, 0);
        textObj.Text =
          jcDataObj.Asu1 + "-" + jcDataObj.Asu2 + "-" + jcDataObj.Asu3;
        textObj.fontSize = fontSize;
        textObj.dAngle = angle;
        if (jcDataObj.ProblemError && jcDataObj.ProblemError.includes("1")) {
          textObj.color = new McCmColor(255, 0, 0);
        }
        textObj.textType = "计算结果";
        textObj.draw(showType == 2);
        this.m_jcData.push(textObj.mcDbId);
      }

      if (jcDataObj.Asd1 && jcDataObj.Asd2 && jcDataObj.Asd3) {
        let textObj = new rlTextData();
        let x = ptCenter.x + gridVecPrep.x * (fontSize * 2 + 50);
        let y = ptCenter.y + gridVecPrep.y * (fontSize * 2 + 50);
        textObj.position = new McGePoint3d(x, y, 0);
        textObj.Text =
          jcDataObj.Asd1 + "-" + jcDataObj.Asd2 + "-" + jcDataObj.Asd3;
        textObj.fontSize = fontSize;
        textObj.dAngle = angle;
        if (jcDataObj.ProblemError && jcDataObj.ProblemError.includes("1")) {
          textObj.color = new McCmColor(255, 0, 0);
        }
        textObj.textType = "计算结果";
        textObj.draw(showType == 2);
        this.m_jcData.push(textObj.mcDbId);
      }
    }
  }

  eraseJcData() {
    if (this.m_jcData && this.m_jcData.length) {
      this.m_jcData.forEach((objId) => {
        objId?.getMcDbEntity().erase();
      });
      this.m_jcData = [];
    }
  }
  //用于撤销回退
  reDraw(obj) {
    super.reDraw(obj);
    this.m_gridData = getEntityData({
      Guid: obj.m_gridData,
      classTypeName: "rlGrid",
    }); //obj.m_gridData.mcDbGridId.getMcDbEntity();
    if (!this.m_gridData) {
      this.m_gridData = getEntityData({
        Guid: obj.m_gridData,
        classTypeName: "rlGridC",
      }); //rlAppObj.rlMxDrawObject.getMxEntity(obj.m_gridData);
    }
    this.Ecc = obj.Ecc;
    this.HDiff1 = obj.HDiff1;
    this.HDiff2 = obj.HDiff2;
    this.HDiffB = obj.HDiffB;
    this.useFunctionNames = JSON.parse(obj.useFunctionNames);
    this.m_RelationGuid = obj.m_RelationGuid;
  }

  // 数据转换
  convert() {
    if (!this.isWasmGeted || (!this.index2dData && !this.index3dData)) {
      // 判断是否是圆弧墙
      let isArc = this.m_gridData.m_centerJoint;
      let ptCenter = null;
      let dRadius = 0;
      if (isArc) {
        ptCenter = this.m_gridData.mcDbGrid.center;
        dRadius = this.m_gridData.mcDbGrid.radius;
      }

      const otherStrengthData =
        this.OtherData && typeof this.OtherData === "string"
          ? JSON.parse(this.OtherData)?.otherStrengthData
          : this.OtherData?.otherStrengthData;

      let res = getPKPM_WallData(
        this.m_sectParamData.Kind,
        Number(this.m_sectParamData.B),
        this.m_gridData.m_stJoint.m_pt[0],
        this.m_gridData.m_stJoint.m_pt[1],
        this.m_gridData.m_edJoint.m_pt[0],
        this.m_gridData.m_edJoint.m_pt[1],
        this.LevelB,
        this.Height,
        this.Ecc,
        this.HDiff1,
        this.HDiff2,
        this.HDiffB,
        this.m_sectParamData.H,
        isArc,
        ptCenter,
        dRadius,
        this.m_gridData.m_stJoint.HDiff
          ? Number(this.m_gridData.m_stJoint.HDiff)
          : 0,
        this.m_gridData.m_edJoint.HDiff
          ? Number(this.m_gridData.m_edJoint.HDiff)
          : 0
      );
      if (!res) return;
      this.getModelDrawData(JSON.parse(res));

      let pt1 = new THREE.Vector3(...this.m_gridData.m_stJoint.m_pt);
      let pt2 = new THREE.Vector3(...this.m_gridData.m_edJoint.m_pt);
      this.OtherData.Length = pt1.distanceTo(pt2).toFixed(0);
      //这里会重新修改otherData的值,导致之前的值会丢失,所以需要重新取
      if (otherStrengthData) {
        this.OtherData.otherStrengthData = otherStrengthData;
      }
      // let wasmData = JSON.parse(res);
      // let data = `{"${this.Guid}":${JSON.stringify(wasmData)}}`;
      // let data3D = this.getModel3dData(data);
      // if (!data3D) return;

      // data3D = JSON.parse(data3D)["3D"][this.Guid];
      // this.points = data3D.Points;
      // this.index3dData = {
      //   points: data3D.Points,
      //   faces: data3D["3dFaces"].map((item) => item.index).flat(),
      // };
    } else {
      if (!Array.isArray(this.index2dData)) {
        // 如果不是数组，则将字符串转换为数组并将元素转换为数字
        this.index2dData = this.index2dData.split(",").map(Number);
      }
    }
  }

  // wasm截面数据转换
  // getModelDrawData(modelData) {
  //   this.index2dData = modelData["upViewData"];
  //   this.SectData = modelData["SectData"];
  //   this.OtherData = JSON.stringify(modelData);
  //   let drawing_3d = modelData["Drawing_3D"];
  //   console.log("drawing_3d", drawing_3d);

  //   this.points = drawing_3d.points;
  //   this.index3dData = {
  //     points: drawing_3d.points,
  //     faces: drawing_3d.faces,
  //   };
  // }

  async draw() {
    this.m_sectGroupName = this.m_sectParamData.B.toString();
    super.draw();
    this.m_gridData ? (this.m_gridData.m_wallId = this.Guid) : "";
    this.CurrtSect = this.m_sectGroupName;
    if (this.m_gridData && this.m_gridData.classTypeName == "rlGrid") {
      await this.m_gridData.drawCheckText();
    }
  }

  updateThisObj(obj, redraw = true, vecMove = null) {
    super.updateThisObj(obj, redraw);
    if (redraw && this.m_gridData.m_wallHoleId) {
      //判断墙上是否有墙洞,同步更新墙洞数据
      let rlWallHoleAssociation = getEntityData({
        Guid: this.m_gridData.m_wallHoleId,
        classTypeName: "rlWallHole",
      });
      if (rlWallHoleAssociation) {
        rlWallHoleAssociation.saveEditRevokeData();
        rlWallHoleAssociation.m_wallEcc = this.Ecc;
        rlWallHoleAssociation.m_wallThick = this.m_sectParamData.B;
        rlWallHoleAssociation.isWasmGeted = false;

        rlWallHoleAssociation.updateThisObj(
          rlWallHoleAssociation,
          true,
          vecMove
        );
      }
    }
  }

  // 克隆
  myClone() {
    let newObj = new rlWallData();
    super.cloneData(newObj);
    newObj.m_gridData = this.m_gridData;
    newObj.Ecc = this.Ecc;
    newObj.HDiff1 = this.HDiff1;
    newObj.HDiff2 = this.HDiff2;
    newObj.HDiffB = this.HDiffB;
    newObj.Color = this.Color;
    newObj.points = this.points;
    newObj.useFunctionNames = this.useFunctionNames;
    newObj.m_RelationGuid = this.m_RelationGuid;
    return newObj;
  }

  transformBy(vecMove) {
    //判断移动方向是否与网格方向垂直
    let stPoint = new THREE.Vector3(...this.m_gridData.m_stJoint.m_pt);
    let edPoint = new THREE.Vector3(...this.m_gridData.m_edJoint.m_pt);
    let gridVec = new THREE.Vector3().subVectors(stPoint, edPoint);

    if (
      // lineDirection.x * lineDirection.y <= 0 &&
      gridVec.x < -0.01 ||
      gridVec.y < -0.01
    ) {
      let tmp = stPoint;
      stPoint = edPoint;
      edPoint = tmp;
      gridVec = new THREE.Vector3().subVectors(stPoint, edPoint);
    }

    // 计算点积
    const dotProduct = gridVec.dot(vecMove);

    // 判断点积是否为零，考虑浮点数精度误差
    const epsilon = 1e-5; // 可以根据需要调整这个阈值
    const arePerpendicular = Math.abs(dotProduct) < epsilon;

    //计算梁的偏轴
    if (arePerpendicular) {
      //计算叉积
      const crossProduct = new THREE.Vector3().crossVectors(gridVec, vecMove);
      if (crossProduct.z < 0) {
        this.Ecc -= vecMove.length();
      } else {
        this.Ecc += vecMove.length();
      }

      // this.draw();
      // this.mcDbId = rlAppObj.mxcadObject.drawEntity(this.mcDbPolyline);
      // this.updateThisObj(this);
    }
    // this.updateThisObj(this);
  }

  getDataBase() {
    let data = super.getDataBase();
    if (!data) return null;
    data["SectGuid"] = this.m_sectParamData.Guid;

    if (this.m_gridData) data["GridGuid"] = this.m_gridData.Guid;

    data["Ecc"] = this.Ecc;
    data["HDiff1"] = this.HDiff1;
    data["HDiff2"] = this.HDiff2;
    data["HDiffB"] = this.HDiffB;
    data["LinkGuids"] = this.LinkGuids?.flat().filter(Boolean).join(",");
    data["useFunctionNames"] = this.useFunctionNames?.join(",");
    data["RelationGuid"] = this.m_RelationGuid;
    data["ModelNoLinkData"] = this.ModelNoLinkData
      ? JSON.stringify(this.ModelNoLinkData)
      : "";

    data["maxWallBeamNo"] = this.maxWallBeamNo ?? 0;
    data["maxWallColNo"] = this.maxWallColNo ?? 0;
    return data;
  }

  //获取图形绘制数据--用于撤销回退
  getDrawData() {
    let data = super.getDrawData();

    data["m_gridData"] = this.m_gridData.Guid;
    data["Ecc"] = this.Ecc;
    data["HDiff1"] = this.HDiff1;
    data["HDiff2"] = this.HDiff2;
    data["HDiffB"] = this.HDiffB;
    data["useFunctionNames"] = JSON.stringify(this.useFunctionNames);
    data["RelationGuid"] = this.m_RelationGuid;
    data["ModelNoLinkData"] = this.ModelNoLinkData;
    data["maxWallBeamNo"] = this.maxWallBeamNo ?? 0;
    data["maxWallColNo"] = this.maxWallColNo ?? 0;
    return data;
  }

  // 删除
  async erase() {
    await checkRelationGuidData(this.Guid, "rlWallSeg");
    //删除墙洞
    if (this.m_HoleId) {
      const objtmp = getEntityData({
        classTypeName: "rlWallHole",
        Guid: this.m_HoleId,
      }); // rlAppObj.rlMxDrawObject.getMxEntity(this.m_beamId);
      if (objtmp) objtmp.erase();
    }
    this.m_gridData ? (this.m_gridData.m_wallId = null) : "";
    this.eraseJcData();
    this.eraseCheckText();
    super.erase();
  }
}

export { rlWallData };
